import React from 'react';
import { ThemeToggleButton } from '../Theme';
import {
  type ChartToolbarButtonSegment,
  type ChartToolbarButtonSize,
} from './chartToolbarButtonPresentation';

interface ChartToolbarButtonProps {
  label: string;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  onClick: () => void;
  selected?: boolean;
  disabled?: boolean;
  size?: ChartToolbarButtonSize;
  segment?: ChartToolbarButtonSegment;
  iconOnly?: boolean;
  title?: string;
}

const ChartToolbarButton: React.FC<ChartToolbarButtonProps> = ({
  label,
  icon,
  children,
  onClick,
  selected,
  disabled = false,
  size = 'default',
  segment,
  iconOnly = false,
  title,
}) => (
  <ThemeToggleButton
    label={label}
    icon={icon}
    iconOnly={iconOnly}
    selected={selected}
    size={size === 'compact' ? 'xs' : 'sm'}
    segment={segment}
    onClick={onClick}
    disabled={disabled}
    title={title ?? label}
  >
    {children}
  </ThemeToggleButton>
);

export default ChartToolbarButton;
